import React, { createContext, useState, useEffect, useContext, useCallback } from 'react';
import api from '../services/api';

const AppContext = createContext();

export const useApp = () => useContext(AppContext);

export const AppProvider = ({ children }) => {
    const [articles, setArticles] = useState([]);
    const [videos, setVideos] = useState([]);
    const [settings, setSettings] = useState({});
    const [sections, setSections] = useState([]);
    const [loading, setLoading] = useState(true);
    const [toast, setToast] = useState({ show: false, message: '', type: 'success' });

    const showToast = (message, type = 'success') => {
        setToast({ show: true, message, type });
        setTimeout(() => setToast({ show: false, message: '', type: 'success' }), 3000);
    };

    const fetchArticles = useCallback(async () => {
        try {
            const res = await api.get('/articles');
            setArticles(res.data);
            return res.data;
        } catch (error) {
            console.error('Error fetching articles:', error);
            return [];
        }
    }, []);

    const fetchVideos = useCallback(async () => {
        try {
            const res = await api.get('/videos');
            setVideos(res.data);
            return res.data;
        } catch (error) {
            console.error('Error fetching videos:', error);
            return [];
        }
    }, []);

    const fetchSettings = useCallback(async () => {
        try {
            const res = await api.get('/settings');
            setSettings(res.data);
            return res.data;
        } catch (error) {
            console.error('Error fetching settings:', error);
            return {};
        }
    }, []);

    const fetchSections = useCallback(async () => {
        try {
            const res = await api.get('/sections');
            setSections(res.data);
            return res.data;
        } catch (error) {
            console.error('Error fetching sections:', error);
            return [];
        }
    }, []);

    const fetchAllData = useCallback(async () => {
        setLoading(true);
        try {
            await Promise.all([
                fetchArticles(),
                fetchVideos(),
                fetchSettings(),
                fetchSections()
            ]);
        } catch (error) {
            console.error('Error fetching all data:', error);
        } finally {
            setLoading(false);
        }
    }, [fetchArticles, fetchVideos, fetchSettings, fetchSections]);

    // Initial load
    useEffect(() => {
        fetchAllData();
    }, []);

    return (
        <AppContext.Provider value={{
            articles,
            videos,
            settings,
            sections,
            loading,
            toast,
            showToast,
            fetchArticles,
            fetchVideos,
            fetchSettings,
            fetchSections,
            fetchAllData
        }}>
            {children}
            {toast.show && (
                <div className={`toast-notification ${toast.type}`}>
                    {toast.message}
                </div>
            )}
        </AppContext.Provider>
    );
};